import React from "react"

import styled, { css } from "styled-components"

import { borderRadius, colors, spacing, typography, size } from "@izettle/otto"

import { InputIcon } from "../../input-icon"
import { CheckboxDecorative, RadioButtonDecorative } from "../../selectors"
import { FOCUS_BORDER_WIDTH } from "../helpers/constants"

export const FocusRemover = React.memo(styled.div`
  width: 100%;
  height: ${size.large};
  max-height: ${size.large};
  display: flex;
  outline: none;
  min-width: 0;
  box-sizing: border-box;
  pointer-events: none;
  padding: 0 ${spacing.small};
  align-items: center;
  border-radius: ${borderRadius.medium};
  &:focus {
    border: ${FOCUS_BORDER_WIDTH} solid ${colors.action.primary.border.default};
    padding: 0 calc(${spacing.small} - ${FOCUS_BORDER_WIDTH});
  }
`)

export const SelectOptionContainer = React.memo(
  styled.div<{ isSelected: boolean; isMultiple?: boolean; disabled?: boolean }>`
    display: flex;
    outline: none;
    background: none;
    border: none;
    cursor: pointer;
    min-height: fit-content;

    ${({ disabled }) =>
      !disabled &&
      css`
        &:hover {
          background: ${colors.background.groupedSecondary};
        }
        &:active {
          background: ${colors.background.groupedSecondary};
        }
      `}

    ${({ isSelected }) => (isSelected ? typography.regularBold : typography.regular)}

    justify-content: ${({ isMultiple }) => (isMultiple ? "flex-start" : "space-between")};
  `,
)

export const SelectOptionContent = React.memo(
  styled.div`
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    justify-content: center;
    flex: 1;
    width: 100%;
    min-width: 0;
  `,
)

export const SelectOptionDescription = React.memo(
  styled.div`
    text-overflow: ellipsis;
    display: block;
    white-space: nowrap;
    overflow: hidden;
    width: 100%;
    text-align: left;
    ${typography.smallSecondary}
  `,
)

export const SelectOptionText = React.memo(
  styled.div<{ disabled?: boolean }>`
    text-overflow: ellipsis;
    display: block;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    width: 100%;
    ${({ disabled }) =>
      disabled &&
      `
      color: ${colors.text.disabled};
    `}
  `,
)

export const SelectCheckbox = React.memo(
  styled(CheckboxDecorative)`
    margin-right: ${spacing.xSmall};
  `,
)

export const SelectRadioButton = React.memo(
  styled(RadioButtonDecorative)`
    margin-right: ${spacing.xSmall};
  `,
)

export const StyledInputIcon = React.memo(
  styled(InputIcon)`
    padding-right: 0;
    padding-left: ${spacing.xSmall};
    color: ${colors.icon.action};
  `,
)

export const StyledImage = React.memo(styled.img`
  padding: 0;
  height: ${size.small};
  width: ${size.small};
  border-radius: ${borderRadius.medium};
  margin-right: ${spacing.xSmall};
`)
